import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, inject, ViewEncapsulation} from '@angular/core';
import {MatSelectModule} from '@angular/material/select';
import {RouterModule, RouterOutlet} from '@angular/router';
import {Store} from "@ngrx/store";
import {selectIsMobileLayout} from "../../../shared/store/app/layout.selectors";

@Component({
	selector: 'main-layout',
	templateUrl: './main-layout.component.html',
	styleUrl: './main-layout.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	standalone: true,
	imports: [
		CommonModule, RouterOutlet, MatSelectModule, RouterModule
	]
})
export class MainLayoutComponent {
	protected store = inject(Store);
	readonly isMobile = this.store.selectSignal(selectIsMobileLayout);
}
